import $ from '/js/header/jquery.js';
export class DaySchedule {
    constructor() {
        // 일단 오늘을 0000-00-00 형식으로 받아옴
        this.day = new Date();
        this.getDaySchedule();
        this.setEventListeners();
    }

    getDaySchedule() {
        $.ajax({
            type: "post",
            url: "/res/main.php",
            data: "mode=day_schedule&auct_date=" + this.day.toISOString().slice(0, 10),
            dataType: "JSON",
            success: (data) => {
                this.wrapBidData(data);
            },
            error: function (xhr, status, error) {
            }
        });
    }

    wrapBidData(data) {
        const week = ['일', '월', '화', '수', '목', '금', '토'][this.day.getDay()];
        // this.day를 12월03일(화) 경매일정 형식으로 변환(백틱으로 표현)
        const ment = `${this.day.getMonth() + 1}월${this.day.getDate()}일(${week}) 경매일정`;
        $(".acDateTitMent").text(ment);
        if (!data.totalCount) {
            $(".acDateTxtMent").html(`<div>일정이 없습니다.</div>`);
            return;
        } else {
            let html = "";
            html += `<div>
              <a href="/ca/caDtList.php?bidDt=${this.day.toISOString().slice(0, 10)}" class="btn-main-week-link">법원전체</a>
            </div>`
            Object.entries(data.item).forEach(([key, value]) => {
                html += `
            <div>
              <a href="/ca/caDtList.php?bidDt=${this.day.toISOString().slice(0, 10)}&sptCd=${value.split("_")[0]}&dptCd=${value.split("_")[1]}" class="btn-main-week-link">${key}</a>
            </div>
        `;
            });
            $(".acDateTxtMent").html(html);
        }
    }

    changeBeforeDate() {
        // 하루전으로 변경하는 로직 필요함
        this.day = new Date(this.day.setDate(this.day.getDate() - 1));
        this.getDaySchedule();
    }

    changeAfterDate() {
        // 하루후로 변경하는 로직 필요함
        // 만약 this.day가 오늘이면 그냥 종료
        this.day = new Date(this.day.setDate(this.day.getDate() + 1));
        this.getDaySchedule();
    }

    setEventListeners() {
        $(".acDateBtnPrev").on("click", () => {
            this.changeBeforeDate();
        });

        $(".acDateBtnNext").on("click", () => {
            this.changeAfterDate();
        });
    }
}